export default __webpack_public_path__ + "static/media/100_3 1.e5d3a3d0.svg";